import { IonBackButton, IonButtons, IonPage } from "@ionic/react";
import { TabRouterPath } from "@src/app/routing/constant/tabRoute";
import { useGetClipboardScoreProfile } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";
import { CLIPBOARD_SCORE } from "@src/appV2/ClipboardScore/constants";
import { AppBarHeader, PageWithHeader } from "@src/appV2/lib";
import { CLIPBOARD_SCORE_FULL_PATH } from "@src/appV2/redesign/ClipboardScore/utils/paths";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useQueryClient } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";

import { RatingCardProps } from "./cards/RatingsCard";
import { RatingCardContainer } from "./cards/RatingsCardContainer";
import { logViewDetailsClicked } from "./logs";
import { getScoreSeverity } from "./utils";

export function RatingsPage() {
  const queryClient = useQueryClient();
  const history = useHistory();
  const { userId } = useDefinedWorker();
  const {
    isLoading: isClipboardScoreLoading,
    data: clipboardScoreData,
    refetch: refetchClipboardScore,
    isSuccess: isClipboardScoreSuccess,
  } = useGetClipboardScoreProfile(userId);

  const scoreDescription = `Your account's ${CLIPBOARD_SCORE} is ${clipboardScoreData?.clipboardScore}. Learn more about how ${CLIPBOARD_SCORE} works.`;

  const displayValue = clipboardScoreData?.clipboardScore ?? 0;

  const handleClipboardScoreClicked = () => {
    logViewDetailsClicked(userId, "attendance score");
    history.push(CLIPBOARD_SCORE_FULL_PATH);
  };

  const isLoading = isClipboardScoreLoading;

  const cards: RatingCardProps[] = [];
  if (isClipboardScoreSuccess) {
    cards.push({
      title: CLIPBOARD_SCORE,
      description: scoreDescription,
      buttonText: "See details",
      buttonOnClick: handleClipboardScoreClicked,
      scoreValue: displayValue,
      scoreColor: getScoreSeverity(displayValue),
      testId: "attendance-score",
      showScoreCol: true,
    });
  }

  function refetchWorkerRankings() {
    queryClient.invalidateQueries({
      predicate: (query) => {
        return query.queryKey?.[0]?.toString().includes("/rankings") ?? false;
      },
    });
  }

  return (
    <IonPage>
      <PageWithHeader
        appBarHeader={
          <AppBarHeader
            leftCta={
              <IonButtons slot="start">
                <IonBackButton
                  data-testid="go-back-button"
                  text=""
                  defaultHref={TabRouterPath.ACCOUNT}
                  mode="ios"
                />
              </IonButtons>
            }
            title="Account Status"
          />
        }
        containerVariant="without-margin"
        containerMaxWidth="lg"
        onRefresh={() => {
          return Promise.all([refetchClipboardScore(), refetchWorkerRankings()]);
        }}
      >
        <RatingCardContainer cards={cards} isLoading={isLoading} />
      </PageWithHeader>
    </IonPage>
  );
}
